<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="b-u-transfer-deposit-detail"
    @beforeOpen="beforeOpen($event, close)"
    classDetail="transfer-deposit-detail"
    @beforeClose="beforeClose"
    @shortkeyAction="shortkeyAction"
    class="capayment-detail"
  >
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide step-1"
        leftIcon="ic-guide"
        @click="guide"
        tooltipIconLeft="Hướng dẫn chức năng"
      />

      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".capayment-detail"></ms-tour>

      <ms-button
        text="Phím tắt"
        tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide step-2"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />

      <div
        class="button icon24 setting-small mr-2"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'"></div>
      <a target="_blank" :href="linkHelp($ms.constant.Help.CAPayment)">
        <div class="button icon24 ic-question mr-2" v-tooltip="'Trợ giúp'" shortkey-target="Help"></div>
      </a>
    </template>
    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="amount-text">Tổng tiền</div>
        <div class="central-title">
          <div class="title-control-group" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>
        <!-- Bên trên -->
        <div class="above-container flex-row" v-show="toggleAbove">
          <div class="above-left flex">
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label>Người nhận</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  :quickAddMulti="quickAddMultiItems"
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObjectCAPayment({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :dropdownWidth="600"
                  :data="accountingObjectCombo"
                  :columns="accountColumns"
                  @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'account')"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  :quickAddMulti="quickAddMultiItems"
                  class="flex mr-2"
                  valueField="accounting_object_id"
                  displayField="accounting_object_code"
                  v-model="model.accounting_object_id"
                  v-model:display="model.accounting_object_code"
                  @selected="
                    ({newData}) => {
                      selectedAccountingObjectCAPayment({newData}, this);
                    }
                  "
                  :initText="model.accounting_object_code"
                  :disabled="viewing"
                  :dropdownWidth="600"
                  :data="comboboxDataRemote.account"
                  :columns="accountColumns"
                  @submitQuickAdd="payload => submitQuickAdd(payload, comboboxDataRemote, 'account')"
                  :queryMode="'remote'"
                  quickSearch="RemoteQuickSearchPopup"
                  :quickSearchParam="quickSearchParam.AccountingObject"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onAccountingObjectComboboxLoadData(payload, null, {
                        dataField: 'account',
                      })
                  "
                  :rules="[
                    {name: $ms.constant.ValidateRule.ForceSelection},
                    {name: $ms.constant.ValidateRule.RiskCustomerVendor},
                  ]"
                  :isValidateRiskCustomerVendor="true"
                  @blur="
                    async (event, me) =>
                      await validateRiskCustomerVendor($ms.constant.ValidateRule.RiskCustomerVendor, me)
                  "
                >
                  <template v-slot:error-extend>
                    <span @mouseleave="() => (isShowRiskPopup = false)">
                      <span
                        v-if="isShowQuestionIcon && riskWarningMessage"
                        class="icon24 ic-information-red ml-1"
                        @mouseover="() => (isShowRiskPopup = true)"
                      ></span>
                      <alert-risk-customer-vendor-popup
                        v-if="isShowRiskPopup && riskWarningMessage"
                        :riskWarningMessage="riskWarningMessage"
                        :taxCode="model.company_tax_code"
                        :referenceDocument="riskWarningMessage.document_name"
                        :riskType="riskWarningMessage.riskType"
                        :closedDate="riskWarningMessage.closedDate"
                        :modifiedDate="riskWarningMessage.modifiedDate"
                      />
                    </span>
                  </template>
                </ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="viewing && !isQuickEditVoucher"
                  v-model="model.accounting_object_name"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Địa chỉ">Địa chỉ</label>
              </div>
              <div class="control-right">
                <ms-input
                  class=""
                  v-model="model.accounting_object_address"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Lý do chi</label>
              </div>
              <div class="control-right">
                <ms-input
                  v-model="model.journal_memo"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Kèm theo</label>
              </div>
              <div class="control-right">
                <ms-input
                  v-model="model.document_included"
                  :disabled="viewing && !isQuickEditVoucher"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group" v-if="isShowVoucherReference">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Tham chiếu">Tham chiếu</label>
              </div>
              <div class="control-right align-item-center voucher-reference">
                <div class="voucher-reference-item" v-if="voucherReferenceItems[0]?.ref_no">
                  <div class="ref-no d-flex">
                    <a class="text-link" @click="showTargetLink(voucherReferenceItems[0])">{{
                      voucherReferenceItems[0]?.ref_no
                    }}</a>
                    <label class="icon24 ic-remove" v-if="!viewing" @click="removeVoucherReference"></label>
                  </div>
                </div>

                <label class="text-link more-voucher-reference icon24" @click="showFormVoucherReference"></label>
              </div>
            </div>
          </div>
          <div class="above-right">
            <div class="seperator-line"></div>
            <div class="flex-row control-group mt-1">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày phiếu chi">Ngày PC</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.ref_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày hạch toán">Ngày HT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing"
                  class="flex2"
                  v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Ngày phiếu chi">Số PC</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing"
                  v-model="model.ref_no"
                  :maxLength="20"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title-right" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Số cam kết chi">Số CKC</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing"
                  v-model="model.bu_commitment_request_ref_no"
                  :maxLength="20"
                  rightIcon="option-tab"
                  :isClickRightIcon="true"
                  @clickRightIcon="onClickCKC(this)"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Bên dưới -->
        <div class="under-container flex1">
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></div>
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></div>
          <ms-resize-screen isFlex class="flex-column flex">
            <template v-slot:content-master>
              <div class="toolbar-grid flex-between">
                <div class="content-left">
                  <div class="item-tabs" :class="{active: selectedTab == 1}" @click="selectedTabHandler(1)">
                    Hạch toán
                  </div>
                  <div class="item-tabs" :class="{active: selectedTab == 2}" @click="selectedTabHandler(2)">
                    Thống kê
                  </div>
                  <div
                    v-if="useTA"
                    class="item-tabs"
                    :class="{active: selectedTab == 3}"
                    @click="selectedTabHandler(3)"
                  >
                    Thuế
                  </div>
                </div>
                <div class="flex-row flex-center">
                  <label class="label text-nowrap">Loại tiền</label>

                  <div class="ml-2 w100px">
                    <ms-combobox
                      :columns="currencyColumns"
                      valueField="currency_code"
                      displayField="currency_code"
                      ref="refCurrencyCode"
                      :data="comboboxDataRemote.currency"
                      v-model="model.currency_code"
                      :initText="model.currency_code"
                      @selected="selectCurrency"
                      :dropdownWidth="600"
                      :class="['input-editor', 'currency-combo']"
                      :queryMode="'remote'"
                      :remoteFilter="true"
                      @blur="assignValueCurrency"
                      @comboboxLoadData="onCurrencyComboboxLoadData"
                      :disabled="viewing"
                    ></ms-combobox>
                  </div>

                  <label
                    class="text-nowrap ml-2"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                    >Tỷ giá</label
                  >

                  <div
                    class="ml-2 w100px"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                  >
                    <ms-number
                      v-model="model.exchange_rate"
                      :formatType="$ms.constant.FormatType.ExchangeRate"
                      :disabled="viewing"
                      @onActionBlur="onActionBlur"
                      :max="999999"
                    ></ms-number>
                  </div>

                  <ms-button
                    :disabled="viewing || !model.accounting_object_id || !isViewInvoce"
                    text="Xem công nợ phải trả"
                    class="ml-4"
                    :hasBorder="true"
                    @click="showRefNoInvoice"
                    type="outline-button circle-button btn-multi-action-detail"
                  />

                  <menu-wrapper class="topnav-widget-more-container ml-2" :maxHeight="200">
                    <template #menu-button="{toggleMenu}">
                      <ms-button
                        :disabled="viewing"
                        text="Định khoản nhanh"
                        :hasBorder="true"
                        type="outline-button circle-button btn-multi-action-detail"
                        @click="toggleMenu"
                        rightIcon="down-arrow-black"
                        :tabindex="-1"
                      />
                    </template>
                    <template #menu-content>
                      <menu-item
                        v-for="(item, index) in accountingActions"
                        :key="index"
                        :seperatorBottom="item.seperatorBottom"
                        @click="clickQuickAccounting(item.id)"
                        >{{ item.text }}</menu-item
                      >
                    </template>
                  </menu-wrapper>
                </div>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 1 || selectedTab == 2">
                <ms-grid-editor
                  :disabled="viewing"
                  :data="model.Detail"
                  v-model:list="model.Detail"
                  :ref="refDetail"
                  formId="transfer-deposit-detail"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggers"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configAccountingGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
              <div class="flex d-flex" v-show="selectedTab == 3">
                <ms-grid-editor
                  formId="transfer-deposit-detail"
                  :disabled="viewing"
                  :data="model.CAPaymentDetailTax"
                  v-model:list="model.CAPaymentDetailTax"
                  :ref="refDetailOther"
                  class="flex-box"
                  idField="ref_detail_id"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggerTaxs"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configTaxGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
            </template>
            <template v-slot:content-item>
              <div class="flex-column flex">
                <div class="toolbar-grid flex-between">
                  <div class="content-left">
                    <div class="item-tabs active">Hạch toán đồng thời</div>
                  </div>

                  <div class="flex-row flex-center">
                    <ms-button
                      type="icon-button"
                      leftIcon="update-down"
                      text="Cập nhật hạch toán đồng thời"
                      @click="generateParallel(true)"
                      :disabled="viewing"
                      class="update-btn"
                    />
                  </div>
                </div>
                <div class="flex d-flex">
                  <ms-grid-editor
                    formId="transfer-deposit-detail"
                    :disabled="viewing"
                    :data="model.Parallels"
                    v-model:list="model.Parallels"
                    ref="refDetailParallel"
                    class="flex-box"
                    idField="ref_detail_id"
                    greyTitle
                    :columns="columnsDataParalell"
                    :propsData="propsData"
                    @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                    :footer="true"
                    @updateBusiness="changeDataBusiness"
                    :changeTriggers="changeTriggerPallers"
                    @onEditEventCellEditor="
                      (colIndex, rowIndex, $grid) => {
                        toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                      }
                    "
                    :name="'gridParallel'"
                    @copyDownRow="copyDownRow"
                    @copyActionClick="copyActionClick"
                    isCopyDataColumn
                    :lineBreak="this.dbOptions?.LineBreak ?? 1"
                    :configVoucherQuickEdit="configParallelGrid"
                    :isQuickEditVoucher="isQuickEditVoucher"
                    :itemRightClicks="itemRightClicks"
                    @afterRightClickAction="viewAccount(this)"
                  ></ms-grid-editor>
                </div>
              </div>
            </template>
          </ms-resize-screen>
        </div>
      </div>
    </template>

    <template v-slot:footer="{}">
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
          <ms-button
            text="Cất"
            class="step-close"
            v-tooltip="'Cất (Ctrl + S)'"
            shortkey-target="Save"
            @click="commandClick($ms.constant.Command.SaveView)"
          ></ms-button>
          <ms-button
            text="Hoãn"
            type="btn-custom"
            class="mr-footer-btn"
            v-tooltip="'Hoãn (Ctrl + U)'"
            shortkey-target="Postpone"
            @click="commandClick($ms.constant.Command.Postpone)"
            v-if="!viewing"
          ></ms-button>
        </div>
        <div class="flex-row" v-if="viewing">
          <ms-button
            text="Sửa"
            class="mr-footer-btn step-8-unposted"
            type="btn-custom"
            v-if="this.isShowEditAndPosted && !this.isFromCompareConvert"
            v-tooltip="'Sửa (Ctrl + E)'"
            shortkey-target="Edit"
            @click="onEditEvent"
            :disabled="offlineReady"
          ></ms-button>

          <ms-button
            text="Ghi sổ"
            title="Ghi sổ (Ctrl + G)"
            class="step-close"
            v-if="this.isShowEditAndPosted"
            shortkey-target="Posted"
            @click="commandClick($ms.constant.Command.Posted)"
            :disabled="offlineReady"
          ></ms-button>
          <!-- start -->
          <div class="flex-row" v-if="this.isShowUnPosted && isQuickEditVoucher" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              v-tooltip="'Cất (Ctrl + S)'"
              class="step-close"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>
            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              @click="commandClick($ms.constant.Command.Postpone)"
            ></ms-button>
          </div>
          <ms-button
            text="Sửa nhanh"
            title="Sửa nhanh"
            class="mr-footer-btn step-7-posted"
            type="btn-custom"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            shortkey-target="QuickEdit"
            @click="eventQuickEditVoucher"
          ></ms-button>
          <!-- end -->
          <ms-button
            text="Bỏ ghi"
            title="Bỏ ghi (Ctrl + B)"
            v-if="this.isShowUnPosted && !isQuickEditVoucher"
            class="step-close"
            shortkey-target="UnPosted"
            @click="commandClick($ms.constant.Command.UnPosted)"
          ></ms-button>
        </div>

        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            class="btn-opacity max-height pl-1"
            @click="refresh"
            v-tooltip="'Nạp (Ctrl + R)'"
            shortkey-target="Refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-pos"
            classCustom="btn-opacity"
            @menuClick="clickItemHandle"
            isBtnFooterHelpFul
            :menuItems="buttonUtilities"
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>

          <div class="seperator-button"></div>

          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            class="max-height step-6-pos"
            isBtnFooterHelpFul
            :menuItems="printMenu"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
            @menuClick="printItemCLick"
            :disabled="!viewing"
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            class="btn-opacity max-height"
            :disabled="!viewing || isShowFromReport || stateApprove"
            @click="onApproveAction"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-unposted"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: $ms.constant.Command.Add})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
        </div>
        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            class="mr-1"
            shortkey-target="ArrowLeft"
            :disabled="!currentIndexBack"
            v-tooltip="'Trước'"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button
            text="Đóng"
            class="mr-2"
            type="btn-custom"
            @click="hide"
            title="Đóng"
            v-tooltip="'Đóng (Ctrl + Q)'"
            shortkey-target="Quit"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import baseDetail from '@/views/base/baseDetail';
import {ModuleCAPayment, ModuleAccountingObject} from '@/stores/moduleConst';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import budgetKindItemAPI from '@/apis/di/budgetKindItemAPI.js';
import budgetItemAPI from '@/apis/di/budgetItemAPI.js';
import {useRemoteCombobox} from '@/setup/remoteCombobox.js';
import {useInitActionCombo} from '../../../commons/combobox/initActionCombo.js';
import {showConfirm, showError} from '@/commons/globalMessage';
import {useCAPaymentDetailData} from './CAPaymentDetailData.js';
import {useCAPaymentDataCommon} from './CAPaymentDataCommon.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import currencyAPI from '@/apis/di/currencyAPI.js';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useCurrencyShowColumn} from '@/commons/gridColumn/CurrencyShowColumn.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import popupUtil from '@/commons/popupUtil';
import {useQuickAccountingVoucher} from '@/setup/utilities/quickAccountingVoucher.js';
import RefType from '@/commons/wildcards/constants/RefType.js';
import {useActionParallel} from '@/commons/gridColumn/ActionParallel.js';
import {showChooseOptionConfirm} from '@/commons/globalMessage';
import GLVoucherAPI from '@/apis/gl/gLVoucherAPI.js';
import MsTour from '@/components/tour/MsTour.vue';
import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import {useCachePurchasePurposeComboConfig} from '@/commons/combobox/cacheCombo/cachePurchasePurposeComboConfig.js';
import {useSelectRefNoInvoice} from '@/views/common/selectRefNoInvoice.js';
import {useCopyNewVoucher} from '@/views/utility/commons/copyNewVoucher.js';
import {useValidateBudgetSourceAccount} from '@/views/utility/commons/validateBudgetSourceAccount.js';
import commonFn from '@/commons/commonFunction.js';
import msResizeScreen from '@/components/resize-wrapper/MsResizeScreen.vue';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import IntegrationInvoiceBotApi from '@/apis/integration/integrationInvoiceBotApi';
import AlertRiskCustomerVendorPopup from '@/views/tax/tARiskCustomerVendor/AlertRiskCustomerVendorPopup.vue';
import {useValidateControl} from '@/setup/validateControl.js';
import maintainDatabaseFn from '@/commons/validateMaintainDatabase.js';

import {reactive, ref, getCurrentInstance, computed, defineProps, onMounted, shallowRef} from 'vue';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MenuWrapper,
    MenuItem,
    MsTour,
    msResizeScreen,
    AlertRiskCustomerVendorPopup,
  },
  extends: baseDetailVoucher,
  name: 'CAPaymentDetail',

  setup: props => {
    const titleCode = 'detail_popup_capaymentdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleCAPayment;
    const isShowRiskPopup = ref(false);

    //Có sử dụng nghiệp vụ Thuế không
    const useTA = ref(false);
    const changeTriggers = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'amount_oc',
      'budget_source_name',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
      'project_expense_code',
      'accounting_object_code',
      'quantity',
    ]);
    const changeTriggerTaxs = shallowRef([
      'project_code',
      'accounting_object_code',
      'turn_over',
      'tax_rate',
      'tax_amount',
    ]);
    const changeTriggerPallers = shallowRef([
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_source_name',
      'amount_oc',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
    ]);
    // NHCUONG 22.06.2023: Các thông tin cho chứng từ tham chiếu
    const voucherReferenceItems = ref([]);
    const isAcceptValidateVoucherReference = ref(false);
    const refTypeAcceptVoucherReference = ref([
      proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
      proxy.$ms.constant.RefType.CAPayment,
      proxy.$ms.constant.RefType.CAPaymentPurchase,
      proxy.$ms.constant.RefType.CAPaymentFixedAsset,
      proxy.$ms.constant.RefType.CAPaymentVendor,
      proxy.$ms.constant.RefType.BAWithDraw,
      proxy.$ms.constant.RefType.BAWithdrawPurchase,
      proxy.$ms.constant.RefType.BAWithDrawFixedAsset,
      proxy.$ms.constant.RefType.BAWithdrawVendor,
      proxy.$ms.constant.RefType.GLGeneralVoucher,
      proxy.$ms.constant.RefType.BUTransferDeposit,
    ]);
    const {validateRiskCustomerVendor, riskWarningMessage, isShowQuestionIcon} = useValidateControl({
      props,
    });

    // biến để check xem có tham chiếu đến chứng từ nào không.
    const isInvoiceInbotReference = ref(true);
    onMounted(() => {
      let dbOptions = {...proxy.$store.state.dbOption.dbOptions};
      if (dbOptions && typeof dbOptions === 'object') {
        useTA.value = dbOptions.UseTA;
      }

      if (proxy._formParam?.isCreateFromInbot) {
        quickSearchParam.AccountingObject.dataFromInvoiceInbot = proxy._formParam?.dataQuickAdd;
      }

      // if (proxy._formParam.IsInsuranceGenerateData) {
      //   useTA.value = !proxy._formParam.IsInsuranceGenerateData;
      // }
    });

    /**
     * Cấu hình ref grid để base đọc
     */
    proxy._gridDetails = {
      Detail: 'refDetail',
      Parallels: 'refDetailParallel',
      CAPaymentDetailTax: 'refDetailOther',
    };

    const quickAddMultiItems = ref([
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Khách hàng, nhà cung cấp',
      },
      {
        valueField: 'EmployeeDetail',
        displayField: 'Cán bộ',
      },
    ]);

    /**
     * Lưu lại ref_no trước khi update phục vụ cập nhật lại refno_finance màn hình InvoiceBot_List
     * HMDUC2 02/01/2023
     */
    const refNoBeforeUpdate = ref('');

    /**
     * Config sửa nhanh chứng từ
     */
    const configAccountingGrid = [
      'description', // diễn giải
      'note', //ghi chú
      'contract_no', //hợp đồng
      'fund_structure_name', //cơ cấu vốn
      'activity_name', // hoạt động
      'fund_code', //loại quỹ
      'statistic_code', // mã thống kê
      'topic_code', //đề tài
      'task_code', //nhiệm vụ
      'is_source_before_year', // nguồn năm trước
      'project_activity_id', //hoạt động dự án
      'project_expense_id', //khoản chi dự án
      'project_expense_code',
    ];

    const configTaxGrid = ['description', 'accounting_object_name', 'accounting_object_address', 'company_tax_code'];

    const configParallelGrid = ['description'];

    const alwayTakeColumns = ['is_posted'];

    let layoutTagDetail = ref('CAPaymentDetail');
    const currentLayout = ref('CAPaymentDetail');
    let layoutTagDetailOther = ref('CAPaymentDetailTax');
    const selectedTabHandler = value => {
      switch (value) {
        case 1:
          layoutTagDetail.value = 'CAPaymentDetail';
          currentLayout.value = 'CAPaymentDetail';
          break;
        case 2:
          layoutTagDetail.value = 'CAPaymentDetailSta';
          currentLayout.value = 'CAPaymentDetailSta';
          break;
        case 3:
          layoutTagDetailOther.value = 'CAPaymentDetailTax';
          currentLayout.value = 'CAPaymentDetailTax';
          proxy.initLayoutDetailOther(); //init lại tránh trường hợp lệch cột tiền
          break;
      }
      selectedTab.value = value;
    };

    const {projectColumns, bankColumns, accountColumns, currencyColumns} = useComboboxColumns();

    // Khởi tạo dữ liệu
    const {
      autoBusiness,
      buttonUtilities,
      buttonPrints,
      columnParallel,
      // submitQuickAdd,
      // comboboxLoadData,
    } = useCAPaymentDetailData();

    const {
      comboboxDataRemote,
      toggleAbove,
      toggleAboveHandler,
      selectedTab,
      accountingObjectComboConfig,
    } = useCAPaymentDataCommon();

    const {comboboxLoadData, submitQuickAdd} = useRemoteCombobox();
    const {onAccountingObjectComboboxLoadData, projectExpenseComboConfig} = useInitActionCombo(
      comboboxDataRemote,
      comboboxLoadData,
    );
    // Combo TK nợ, có
    const {cacheAccountDebitCombo, cacheAccountCreditCombo, cacheAccountTaxCreditCombo} = useCacheAccountComboConfig();

    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    // Combo nguồn
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    // Combo chương
    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();
    // Combo loại, khoản
    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();
    // Combo mục tiểu mục tiết tiểu mục
    const {
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetDetailItemComboConfig,
    } = useCacheBudgetItemComboConfig();
    // Combo dự án
    const {cacheProjectComboConfig} = useCacheProjectComboConfig();
    // Combo khách hàng, nhà cung cấp, cán bộ
    const {cacheAccountingObjectComboConfig, accountingObjectCombo} = useCacheAccountingObjectComboConfig();
    // Combo hoạt động
    const {cacheActivityComboConfig} = useCacheActivityComboConfig();
    // Combo mã thống kê
    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();
    // Combo TK NH,KB
    const {cacheBankInfoComboConfig} = useCacheBankInfoComboConfig();
    // Combo hợp đồng
    const {cacheContractComboConfig} = useCacheContractComboConfig();
    // Combo đề tài
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    // Combo nhiệm vụ
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    // Combo mã dự phòng
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();
    // Combo cấp phát
    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    // Combo loại quỹ
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    // Combo phí, lệ phí
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();
    // Combo Nhóm HĐV (Tab thuế)
    const {cachePurchasePurposeComboConfig} = useCachePurchasePurposeComboConfig();

    const {showRefNoInvoice, isViewInvoce} = useSelectRefNoInvoice();

    // Cấu hình các field của grid
    const propsData = {
      //checkmaxLength
      org_ref_no: {
        maxLength: 200,
      },
      description: {
        maxLength: 255,
      },
      amount: {
        max: proxy.$ms.constant.RangeOfNumber.MaxAmount,
        min: proxy.$ms.constant.RangeOfNumber.MinAmount,
      },
      //thuế
      turn_over: {
        min: 0,
      },
      inv_series: {
        maxLength: 20,
      },
      tax_amount: {
        min: 0,
      },
      inv_type_code: {
        maxLength: 25,
      },
      inv_series: {
        maxLength: 20,
      },
      inv_no: {
        maxLength: 20,
      },
      accounting_object_name: {
        maxLength: 255,
      },
      accounting_object_address: {
        maxLength: 255,
      },
      company_tax_code: {
        maxLength: 50,
      },

      budget_source_name: cacheBudgetSourceComboConfig,
      budget_chapter_code: cacheBudgetChapterComboConfig,
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      budget_item_code: cacheBudgetItemComboConfig,
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      budget_detail_item_code: cacheBudgetDetailItemComboConfig,
      debit_account: cacheAccountDebitCombo,
      credit_account: cacheAccountCreditCombo,
      tax_account: cacheAccountTaxCreditCombo,
      method_distribute_name: {
        enum: 'MethodDistributeType',
        modelValueField: 'method_distribute_type',
        dropdownWidth: 200,
      },
      cash_withdraw_type_name: {
        enum: 'CashWithDrawType',
        modelValueField: 'cash_withdraw_type_id',
        dropdownWidth: 300,
      },
      tax_rate: {
        enum: 'TaxRateInventory',
        modelValueField: 'tax_rate',
      },
      inv_type: {
        enum: 'InvType',
        modelValueField: 'inv_type',
      },
      project_code: cacheProjectComboConfig,
      accounting_object_code: accountingObjectComboConfig,
      activity_name: cacheActivityComboConfig,
      statistic_code: cacheStatisticComboConfig,
      bank_account: cacheBankInfoComboConfig,
      contract_no: cacheContractComboConfig,
      topic_code: cacheTopicComboConfig,
      task_code: cacheTaskComboConfig,
      budget_provide_code: cacheBudgetProvideComboConfig,
      fund_structure_name: cacheFundStructureComboConfig,
      fund_code: cacheFundComboConfig,
      budget_fees_code: cacheBudgetFeesComboConfig,
      purchase_purpose_code: cachePurchasePurposeComboConfig,
      project_expense_code: projectExpenseComboConfig,
      rowAction: ['Insert', 'Delete'],
    };

    const subSystemCode = proxy.$ms.constant.SubSystemCode.CAPayment;

    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      AccountingObject: {
        titleSearch: 'đối tượng',
        payload: {
          sort: 'is_employee,accounting_object_code',
        },
        module: ModuleAccountingObject,
        idField: 'accounting_object_id',
      },
    });

    /**
     * Override để tính lại tổng tiền khi chọn mục thuế
     * TPNAM 13.04.2022
     * UPDATE NCQUYEN 26/07/2022
     */

    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);
      //custom switch case
      switch (dataField) {
        // Tính tiền thuế = Giá tính thuế * Thuế xuất;
        // Tính tiền quy đổi = tiền thuế * tỷ giá;
        // Xử lý khi thay đổi giá tính thuế
        case 'turn_over':
          var taxAmountValue;
          var amountValue;
          if ($grid.columnx.find(x => x.dataField == 'turn_over')) {
            let tax_rate = $grid.dataView[rowIndex].tax_rate || 0;
            // Nếu thuế xuất = KCT thì tiền thuế = 0, quy đổi =0;
            if (tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected) {
              taxAmountValue = 0;
              amountValue = 0;
            } else {
              // Tính tiền thuế
              taxAmountValue = tracking.newVal * (tax_rate / 100);
              // Tính tiền quy đổi
              amountValue = commonFn?.roundDecimalDbOption(
                proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
                tracking.newVal * (tax_rate / 100) * proxy.model.exchange_rate
              ) ||  tracking.newVal * (tax_rate / 100) * proxy.model.exchange_rate;
            }
            callbackUpdateRow({tax_amount: taxAmountValue}, rowIndex);
            callbackUpdateRow({amount: amountValue}, rowIndex);
          }
          break;
        // Xử lý khi thay đổi thuế xuất
        case 'tax_rate':
          if ($grid.columnx.find(x => x.dataField == 'tax_rate')) {
            let tax_rate = $grid.dataView[rowIndex].tax_rate || 0;
            let turn_over = $grid.dataView[rowIndex].turn_over || 0;
            // Nếu thuế xuất = KCT thì tiền thuế = 0, quy đổi =0;
            if (tax_rate == proxy.$ms.constant.TaxRateInventory.NoSelected) {
              taxAmountValue = 0;
              amountValue = 0;
            } else {
              // Tính tiền thuế
              taxAmountValue = (tax_rate / 100) * turn_over;
              // Tính tiền quy đổi
              amountValue = commonFn?.roundDecimalDbOption(
                proxy?.$ms?.constant?.DbOptionKey?.CurrencyDecimalDigits,
                (tax_rate / 100) * turn_over * proxy.model.exchange_rate
              ) || (tax_rate / 100) * turn_over * proxy.model.exchange_rate;
            }
            callbackUpdateRow({tax_amount: taxAmountValue}, rowIndex);
            callbackUpdateRow({amount: amountValue}, rowIndex);
          }
          break;
        case 'accounting_object_code':
          callbackUpdateRow({
            accounting_object_name: metaData?.accounting_object_name,
            accounting_object_address: metaData?.address,
            company_tax_code: metaData?.company_tax_code,
          }, rowIndex);
          break;
        default:
          break;
      }
    };

    /**
     *  Override gắn thêm dữ liệu mặc định khi mở form
     * TPNAM 12.07.2022
     * UPDATE NCQUYEN 26.07.2022
     */
    async function bindData(data) {
      if (data.ref_id || proxy._formParam.mode == proxy.$ms.constant.FormState.Add) {
        data.credit_ref_no = null;
        data.increment_ref_no = null;
        data.inward_ref_no = null;
        // Tổng tiền
        data.total_amount = data.total_amount || 0;
        data.total_tax_amount = data.total_tax_amount || 0;
        // Tổng thuế
        data.tax_rate = data.tax_rate || 0;
        data.total_payment_amount = data.total_amount_oc + data.total_tax_amount || 0;

        data.posted_date = data.posted_date || proxy.postedDate;
        data.ref_date = data.ref_date || proxy.postedDate;
        // Loại tiền mặc định là tiền VND
        data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
        // Tỷ giá
        data.exchange_rate = data.exchange_rate || 1;
        currencyCode.value = data.currency_code;
        data.ref_no = data?.ref_no ?? null;

        proxy.super('bindData', baseDetailVoucher, data);
        // sinh hạch toán đồng thời
        if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
          await proxy.generateParallel(true, true);
          assignDataEmptyToParallel(proxy);
        }

        // NHCUONG 22.06.2023: Bổ sung thêm chứng từ tham chiếu
        if (data.VoucherReferences && data.VoucherReferences.length > 0) {
          setVoucherReferenceInfo(
            data.VoucherReferences.map(item => ({
              ...item,
              ref_id: item.to_ref_id,
              ref_no: item.to_ref_no,
              ref_type: item.to_ref_type,
              budget_source_id: item.from_budget_source_id,
              budget_kind_item_code: item.from_budget_kind_item_code,
              budget_sub_kind_item_code: item.from_budget_sub_kind_item_code,
              budget_chapter_code: item.from_budget_chapter_code,
              budget_item_code: item.from_budget_item_code,
              budget_sub_item_code: item.from_budget_sub_item_code,
              task_id: item.from_task_id,
              statistic_id: item.from_statistic_id,
              project_id: item.from_project_id
            }))
          );
        } else {
          setVoucherReferenceInfo([]);
        }

        // chỉ lấy thằng đầu tiên khi tham chiếu đến hóa đơn
        if (data.DetailInbotReference && data.DetailInbotReference.length > 0) {
          voucherReferenceItems.value = data.DetailInbotReference;
          voucherReferenceItems.value.forEach((item, index) => {
            item.ref_no = data.DetailInbotReference[index].invoice_no;
          });
        }
        isAcceptValidateVoucherReference.value = false;

        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
        if (proxy.viewing) {
          if (proxy.model.is_posted) {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('posted') || x.state.includes('default'));
          } else {
            stepsDynamic.value = steps.value.filter(x => x.state.includes('unposted') || x.state.includes('default'));
          }
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
        }
        // HMDUC2: Lưu lại biến ref_no trước khi update
        proxy.refNoBeforeUpdate = JSON.stringify(data?.ref_no);
      }
    }

    /**
     * Ovrride để Gán lại tham số trước khi save
     * TPNAM 30.03.2022
     */
    function getSaveData(mode, action) {
      const messageInvalid = validateMaxLength(proxy.model);
      if (messageInvalid) {
        let mestitle = 'Cất không thành công';
        showError(messageInvalid, mestitle, 450);
        return false;
      }

      var data = proxy.super('getSaveData', baseDetailVoucher, mode, action);
      data.ref_type = proxy.$ms.constant.RefType.CAPayment;
      data.ref_type_name = proxy.$t('i18nEnum.RefType.CAPayment');

      if (data.refTypes) {
        data.refTypes.RefTypeForeignKey = proxy.$ms.constant.RefType.BADeposit;
      }

      if (!data.bu_commitment_request_ref_no) {
        data.bu_commitment_request_id = null;
      }

      // NHCUONG 22.06.2023: Bổ sung thêm lưu chứng từ tham chiếu
      if (voucherReferenceItems.value.length > 0) {
        const refDetailIds = voucherReferenceItems.value.map(item => item.from_ref_detail_id);

        const voucherReferences = proxy.model.Detail.filter(item => {
          if (refDetailIds.includes(item.ref_detail_id)) {
            const voucherReference = voucherReferenceItems.value.find(
              vourcher => vourcher.from_ref_detail_id === item.ref_detail_id,
            );
            if (
              voucherReference &&
              voucherReference.budget_source_id === item.budget_source_id &&
              voucherReference.budget_kind_item_code === item.budget_kind_item_code &&
              voucherReference.budget_sub_kind_item_code === item.budget_sub_kind_item_code &&
              voucherReference.budget_chapter_code === item.budget_chapter_code &&
              voucherReference.budget_item_code === item.budget_item_code &&
              voucherReference.budget_sub_item_code === item.budget_sub_item_code &&
              voucherReference.task_id === item.task_id &&
              voucherReference.statistic_id === item.statistic_id &&
              voucherReference.project_id === item.project_id
            )
              return item;
          }
        });
        if (voucherReferences.length > 0) {
          data.VoucherReferences = voucherReferences.map(item => ({
            ...item,
            to_ref_id: voucherReferenceItems.value[0]?.ref_id,
            to_ref_no: voucherReferenceItems.value[0]?.ref_no,
            to_ref_type: voucherReferenceItems.value[0]?.ref_type,
            from_budget_source_id: item.budget_source_id,
            from_budget_kind_item_code: item?.budget_kind_item_code,
            from_budget_sub_kind_item_code: item?.budget_sub_kind_item_code,
            from_budget_chapter_code: item?.budget_chapter_code,
            from_budget_item_code: item?.budget_item_code,
            from_budget_sub_item_code: item?.budget_sub_item_code,
            from_task_id: item?.task_id,
            from_statistic_id: item?.statistic_id,
            from_project_id: item?.project_id,
            from_ref_detail_id: item?.ref_detail_id,
          }));
        } else {
          data.VoucherReferences = [];
        }
      } else {
        data.VoucherReferences = [];
      }
      data.IsAcceptValidateVoucherReference = isAcceptValidateVoucherReference.value;
      isAcceptValidateVoucherReference.value = false;

      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.isSaveOffline = proxy?.offlineReady;
      if (data.isSaveOffline && !data.state) {
        data.state = proxy.$ms.constant.FormState.Add;
      }
      data.IsInvoiceInbotReference = isInvoiceInbotReference.value;
      return data;
    }

    /**
     * Validate max lenght khi sinh từ chứng từ inbot
     * Created by NNKiem 17/11/2023
     */
    function validateMaxLength(data) {
      const invalidFields = [];
      if (data.accounting_object_address && data.accounting_object_address.length > 255) {
        invalidFields.push(
          `<div><span class="color-green">Địa chỉ</span> không được vượt quá 255 kí tự. Vui lòng kiểm tra lại.</div>`,
        );
      }
      if (data.journal_memo && data.journal_memo.length > 255) {
        invalidFields.push(
          `<div><span class="color-green">Lý do chi</span> không được vượt quá 255 kí tự. Vui lòng kiểm tra lại.</div>`,
        );
      }
      return invalidFields.length > 0 ? invalidFields.join('') : null;
    }

    /**
     * Hàm thực hiện set lấy thêm reftype để xử lý cho autoID
     * NXCHIEN 27.05.2022
     */
    function customVoucherLoadData(result) {
      const me = this;
      me.super('customVoucherLoadData', baseDetailVoucher, result);
      let formDetail = me._formParam.name.substring(0, me._formParam.name.length - 6);
      // lấy ra giá trị ref_type
      if (formDetail) {
        result.param = JSON.stringify({
          RefTypeKey: me.$ms.constant.RefType[formDetail],
          RefTypeForeignKey: me.$ms.constant.RefType.INInward,
        });
      }
    }

    const {configColumnParalell} = useActionParallel();

    /**
     * Override Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * dqdat1 27.07.2022
     */
    function getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return configColumnParalell;
    }

    const {clickItemCopyVoucher} = useCopyNewVoucher(proxy, 'Detail');

    /**
     * Action click button Tiện ích
     * NCQUYEN 19.07.2022
     */
    const clickItemHandle = item => {
      switch (item.command) {
        // Thêm mới
        case proxy.$ms.constant.Command.Add:
          proxy.add({
            mode: proxy.$ms.constant.FormState.Add,
          });
          break;
        // Thêm mới chứng từ hiện thời
        case proxy.$ms.constant.Command.Duplicate:
          item.form = item.form ?? 'CAPaymentDetail';
          item.refType = item.refType ?? proxy.$ms.constant.RefType.CAPayment;
          clickItemCopyVoucher(item);
          break;
        // Xóa chứng từ hiện thời
        case proxy.$ms.constant.Command.Delete:
          proxy.delete(proxy.model);
          break;
        // Xem số dư tài khoản
        case proxy.$ms.constant.Command.ViewAccount:
          viewAccount(proxy);
          break;
        // Cất thành định khoản tự động
        case proxy.$ms.constant.Command.AddAutoBusiness:
          saveAsNewAutoBusiness();
          break;
        // Hạch toán chi phí lương (để đến phần lương)
        case proxy.$ms.constant.Command.GLVoucherDetail:
          generateGLVoucher();
          break;
        // Sao chép chứng từ
        case proxy.$ms.constant.Command.Copy:
          proxy.clickCopyVoucher();
          break;
        //Xem số dư tạm ứng
        case proxy.$ms.constant.Command.ViewAdvanceBalance:
          getAdvanceBalance();
          break;
      }
      proxy.pushTrans(item.command);
    };

    /**
     * Hàm sinh hạch toán chi phí lương
     * NNLINH 03.11.2022
     */
    async function generateGLVoucher() {
      // check quyền Thêm (vqphong - 12/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);

      let details = {...proxy.model};
      details.IsGenerateData = true;
      let dataTrans = await GLVoucherAPI.getDataByRelationRefId(details.ref_id);
      if (dataTrans) {
        let mes = proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncFundSalaryContent');
        showConfirm(
          mes.format('Phiếu chi', dataTrans.ref_no),
          proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherTitle'),
        ).then(answer => {
          switch (answer) {
            case true:
              // check quyền Sửa (vqphong - 12/12/2022)
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
              details.IsSyncData = true;
              popupUtil.show('GLGeneralVoucherDetail', {
                mode: proxy.$ms.constant.FormState.Edit,
                refType: proxy.model.ref_type,
                // id: proxy.model.ref_id,
                data: details,
                options: {
                  submit: data => {
                    proxy.view({
                      id: proxy.model.ref_id,
                      mode: proxy.$ms.constant.FormState.View,
                    });
                  },
                },
              });
              break;
            case false:
              break;
          }
        });
      } else {
        popupUtil.show('GLGeneralVoucherDetail', {
          mode: proxy.$ms.constant.FormState.Add,
          refType: proxy.model.ref_type,
          data: details,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      }
    }
    //#region config ẩn hiện cột và sự kiện liên quan đến combo Loại tiền
    const {columnsDataParalell} = useCurrencyShowColumn(proxy, columnParallel);
    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      totalAmountComputed,
      assignValueCurrency,
      onActionBlur,
      currencyCode,
      isFirst,
    } = useCurrencyCombo(comboboxDataRemote, comboboxLoadData, proxy, 'Detail', 'Parallels', 'CAPaymentDetailTax');
    //#endregion

    // Validate tài khoản và nguồn
    const {onPosted, customUnPostedSuccess} = useValidateBudgetSourceAccount();

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * TPNAM 12.06.2022
     */
    function customColumns(columns) {
      isFirst.value = false;
      if (proxy.model.currency_code && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
        columns.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
        proxy.columnsDataParalell.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      }
    }

    const {
      changeDataBusinessCommon, // Cập nhật dữ liệu 1 dòng khi sửa dòng dữ liệu trên grid
      toggleAboveHandlerGrid, // mặc định trong Danh mục và trong DBOption
      bindDefaultData,
      getDataDefault,
      defaultData, // Giá trị mặc định trong danh mục TK ngầm định
      onClickCKC,
      copyDownRow,
      copyActionClick,
      assignDataEmptyToParallel,
    } = useActionGridEditor(proxy);

    getDataDefault(proxy.$ms.constant.RefType.CAPayment);
    const {
      onBlurActionDatePicker, // sự kiện input Ngày phiếu chi
      selectedAccountingObject, // Sự kiện khi chọn cán bộ/KH, NCC
      viewAccount, // xem số dư tài khoản
    } = useInforCommons();

    /**
     * Custom Default của grid
     * NCQUYEN 19.07.2022
     */
    function customDefaultData($grid, me, rowIndex) {
      //Tài khoản thuế
      if (defaultData.value && defaultData.value.allow_default_setting) {
        $grid.dataView[rowIndex].tax_account = defaultData.value.default_tax_account_id;
      }
      //Số lượng
      $grid.dataView[rowIndex].quantity = 0;
      //Loại hóa đơn
      $grid.dataView[rowIndex].inv_type = me.$ms.constant.InvType.InvoiceGTGT;
      //Mã số thuế
      if (me.model.company_tax_code) {
        $grid.dataView[rowIndex].company_tax_code = me.model.company_tax_code;
      } else {
        $grid.dataView[rowIndex].company_tax_code = '';
      }
      //Đối tượng khác
      if (me.model.accounting_object_name) {
        $grid.dataView[rowIndex].accounting_object_name = me.model.accounting_object_name;
      } else {
        $grid.dataView[rowIndex].accounting_object_name = '';
      }
      //Địa chỉ
      if (me.model.accounting_object_address) {
        $grid.dataView[rowIndex].accounting_object_address = me.model.accounting_object_address;
      } else {
        $grid.dataView[rowIndex].accounting_object_address = '';
      }
    }

    /**
     * Định khoản nhanh
     * NCQUYEN 11.07.2022
     */
    const {refType, clickQuickAccounting, accountingActions, saveAsNewAutoBusiness} = useQuickAccountingVoucher({
      gridDetails: proxy._gridDetails,
    });

    /**
     * Lấy tất cả định khoản nhanh theo loại chứng từ
     * NCPHUOC 05/07/2022
     */
    refType.value = RefType.CAPayment;

    /**
     * Config tùy chỉnh giao diện
     */
    const getConfigLayout = () => {
      return {
        layouts: [
          {tag: 'CAPaymentDetail', name: 'Hạch toán'},
          {tag: 'CAPaymentDetailSta', name: 'Thống kê'},
          {tag: 'CAPaymentDetailTax', name: 'Thuế'},
        ],
      };
    };

    /**
     * Xử lý bind data khi sinh chứng từ nộp thuế TNCN
     * NHANH3 1.11.2022
     * modified by DVMINH 22/01/2024 - Truyền thêm tham số load từ base để khử duplicate request
     */
    async function beforeBindData(dataModel) {
      const me = proxy;
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsPayIncomeTax &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });
        //Trường hợp sinh từ nộp thuế
        me.model = proxy._formParam.data;
        me.model.ref_no = data?.ref_no;
        me.model.ref_date = proxy.postedDate;
        me.model.posted_date = proxy.postedDate;
        me.model.IsPayIncomeTax = true;
        me.model.ref_type = data.ref_type;
        me.model.CAPaymentDetailTax = [];
        me.model.CAPaymentDetailTax.push(me.model.Detail[0]);
        me.model.Parallels = [];
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = data.currency_code;
        me.model.Detail.forEach(e => {
          //#region Gắn lại thông tin MLNS ngầm định
          // Nguồn
          if (me.dbOptions.DefaultBudgetSourceID) {
            e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
            e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
            // lấy thêm DefaultBudgetSourceGroupPropertyType
            e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
          }

          // Chương
          if (me.dbOptions.DefaultBudgetChapterCode) {
            e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
            e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
          }

          // Loại
          if (me.dbOptions.DefaultBudgetKindItemCode) {
            e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
            e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
          }

          // Khoản
          if (me.dbOptions.DefaultBudgetSubKindItemCode) {
            e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
            e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
          }

          // nghiệp vụ
          if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
            e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
            e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
              formatType: 100,
              enumName: 'CashWithDrawType',
            });
          }

          // Hình thức cấp phát
          if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
            e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
            e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
              formatType: 100,
              enumName: 'MethodDistributeType',
            });
          }
          // Loại quỹ
          if (me.dbOptions.DefaultFundID) {
            e.fund_id = me.dbOptions.DefaultFundID;
            e.fund_code = me.dbOptions.DefaultFundCode;
          }
          //#endregion
        });
      }

      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsInsuranceGenerateData &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });
        //Trường hợp sinh từ nộp bảo hiểm
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.ref_date = data.ref_date;
        (me.model.pa_from_month = proxy._formParam.pa_from_month),
          (me.model.pa_to_month = proxy._formParam.pa_to_month),
          (me.model.pa_year = proxy._formParam.pa_year),
          (me.model.Parallels = []);
        me.model.is_pay_insurance = true;
        me.model.ref_type = data.ref_type;
        me.model.posted_date = data.ref_date;
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = data.currency_code;

        // nghiệp vụ
        let cash_withdraw_type_id = null,
          cash_withdraw_type_name = null;
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          cash_withdraw_type_id = me.$ms.constant.CashWithDrawType.Expense;
          cash_withdraw_type_name = me.$ms.format.formatData(me.$ms.constant.CashWithDrawType.Expense, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        let method_distribute_type = null,
          method_distribute_name = null;
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }

        //Bind lại hình thức cấp phát, nghiệp vụ
        me.model.Detail.forEach(e => {
          e.cash_withdraw_type_id = cash_withdraw_type_id;
          e.cash_withdraw_type_name = cash_withdraw_type_name;
          e.method_distribute_type = method_distribute_type;
          e.method_distribute_name = method_distribute_name;
        });

        await proxy.generateParallel(true, true);
      }

      // Sinh chứng từ nộp thuế NHANH3 6.1.2023
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsPayTax &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        // DVMINH khử duplicate request
        // Lấy lại dữ liệu autoID...
        // let data = await proxy.loadData('New', {
        //   mode: proxy.$ms.constant.FormState.Add,
        // });
        //Trường hợp sinh từ nộp thuế
        me.model = proxy._formParam.data;
        me.model.ref_no = dataModel.ref_no;
        me.model.ref_date = proxy.postedDate;
        me.model.posted_date = proxy.postedDate;
        me.model.Parallels = [];
        me.model.ref_type = dataModel.ref_type;
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = dataModel.currency_code;
        me.model.Detail.forEach(e => {
          //#region Gắn lại thông tin MLNS ngầm định
          // Nguồn
          if (me.dbOptions.DefaultBudgetSourceID) {
            e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
            e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
            // lấy thêm DefaultBudgetSourceGroupPropertyType
            e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
          }

          // Chương
          if (me.dbOptions.DefaultBudgetChapterCode) {
            e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
            e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
          }

          // Loại
          if (me.dbOptions.DefaultBudgetKindItemCode) {
            e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
            e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
          }

          // Khoản
          if (me.dbOptions.DefaultBudgetSubKindItemCode) {
            e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
            e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
          }

          // nghiệp vụ
          if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
            e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
            e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
              formatType: 100,
              enumName: 'CashWithDrawType',
            });
          }

          // Hình thức cấp phát
          if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
            e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
            e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
              formatType: 100,
              enumName: 'MethodDistributeType',
            });
          }
          // Loại quỹ
          if (me.dbOptions.DefaultFundID) {
            e.fund_id = me.dbOptions.DefaultFundID;
            e.fund_code = me.dbOptions.DefaultFundCode;
          }
          //#endregion
        });
      }

      //Sinh chứng từ xử lý chênh lệch Bảng kê kiểm quỹ
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.isFundInventory &&
        proxy.editMode === proxy.$ms.constant.FormState.Add
      ) {
        await beforeBindDataFundInventory(proxy._formParam.data);
      }
    }

    /**
     * Hàm bindData khi sinh ct xử lý chênh lệch bảng kê kiểm quỹ
     * NNLINH 16.08.2023
     */
    async function beforeBindDataFundInventory(dataGenerate) {
      const me = proxy;
      // Lấy lại dữ liệu autoID...
      let data = await proxy.loadData('New', {
        mode: proxy.$ms.constant.FormState.Add,
      });
      //master
      me.model = dataGenerate;
      me.model.ref_no = data.ref_no;
      me.model.ref_date = proxy.postedDate;
      me.model.Parallels = [];
      me.model.is_fund_inventory = true;
      me.model.fund_inventory_ref_id = proxy._formParam.fund_inventory_ref_id;
      me.model.ref_type = data.ref_type;
      me.model.posted_date = proxy.postedDate;
      currencyCode.value = dataGenerate.currency_code;

      //Bind lại hình thức cấp phát, nghiệp vụ
      me.model.Detail.forEach(e => {
        e.ref_id = me.model.ref_id;
        //#region Gắn lại thông tin MLNS ngầm định
        // Nguồn
        if (me.dbOptions.DefaultBudgetSourceID) {
          e.budget_source_id = me.dbOptions.DefaultBudgetSourceID;
          e.budget_source_name = me.dbOptions.DefaultBudgetSourceName;
          // lấy thêm DefaultBudgetSourceGroupPropertyType
          e.budget_source_group_property_type = me.dbOptions.DefaultBudgetSourceGroupPropertyType;
        }

        // Chương
        if (me.dbOptions.DefaultBudgetChapterCode) {
          e.budget_chapter_code = me.dbOptions.DefaultBudgetChapterCode;
          e.budget_chapter_id = me.dbOptions.DefaultBudgetChapterId;
        }

        // Loại
        if (me.dbOptions.DefaultBudgetKindItemCode) {
          e.budget_kind_item_code = me.dbOptions.DefaultBudgetKindItemCode;
          e.budget_kind_item_id = me.dbOptions.DefaultBudgetKindItemId;
        }

        // Khoản
        if (me.dbOptions.DefaultBudgetSubKindItemCode) {
          e.budget_sub_kind_item_code = me.dbOptions.DefaultBudgetSubKindItemCode;
          e.budget_sub_kind_item_id = me.dbOptions.DefaultBudgetSubKindItemId;
        }

        // nghiệp vụ
        if (me.dbOptions.DefaultCashWithDrawTypeID != null && me.dbOptions.DefaultCashWithDrawTypeID != undefined) {
          e.cash_withdraw_type_id = me.dbOptions.DefaultCashWithDrawTypeID;
          e.cash_withdraw_type_name = me.$ms.format.formatData(me.dbOptions.DefaultCashWithDrawTypeID, {
            formatType: 100,
            enumName: 'CashWithDrawType',
          });
        }

        // Hình thức cấp phát
        if (me.dbOptions.DefaultMethodDistributeID != null && me.dbOptions.DefaultMethodDistributeID != undefined) {
          e.method_distribute_type = me.dbOptions.DefaultMethodDistributeID;
          e.method_distribute_name = me.$ms.format.formatData(me.dbOptions.DefaultMethodDistributeID, {
            formatType: 100,
            enumName: 'MethodDistributeType',
          });
        }
        // Loại quỹ
        if (me.dbOptions.DefaultFundID) {
          e.fund_id = me.dbOptions.DefaultFundID;
          e.fund_code = me.dbOptions.DefaultFundCode;
        }
        //#endregion
      });

      await proxy.generateParallel(true, true);

      if (dataGenerate.VoucherReferences && dataGenerate.VoucherReferences.length > 0) {
        setVoucherReferenceInfo(dataGenerate.VoucherReferences);
      }
    }

    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    /**
     * Mở in chứng từ
     * TPNAM 25.08.2022
     */
    function itemCLick(report) {
      proxy.printVoucher(report);
    }
    /**
     * Hàm gửi tham số Report lên BE để in
     * NBTIN 1.11.2022
     */
    function getCustomReportParams(reportId) {
      let param = {};

      switch (reportId) {
        case '106.C37CT':
          param.$RefID = proxy.model.ref_id;
          param.$RefType = proxy.$ms.constant.RefType.CAPayment;
          break;

        default:
          param.ref_id = proxy.model.ref_id;
          param.ref_type = proxy.$ms.constant.RefType.CAPayment;
          break;
      }

      return param;
    }
    /**
     * custom thêm 1 số trường khi copy cột
     * TVDAT 09/11/2022
     */
    function copyDownRowExtend(
      objAssign,
      metaData,
      column,
      $grid,
      lastIndex,
      rowIndex,
      isShowCombo,
      callbackUpdateRow,
    ) {
      switch (column.dataField) {
        //Xử lý khi thay đổi thuế suất
        case 'tax_rate':
          let currentTaxRate = objAssign.tax_rate;
          for (let i = rowIndex; i <= lastIndex; i++) {
            if (currentTaxRate == $grid.$ms.constant.TaxRateInventory.NoSelected) {
              $grid.dataView[i].tax_amount = 0;
            } else {
              $grid.dataView[i].tax_amount = commonFn.roundDecimalDbOption(
                proxy.$ms.constant.DbOptionKey.CurrencyDecimalDigits,
                (currentTaxRate * ($grid.dataView[i].turn_over || 0)) / 100,
              );
            }
          }

          break;
        //Xử lý khi thay đổi giá tính thuế
        case 'turn_over':
          let turnOver = objAssign.turn_over;
          for (let i = rowIndex; i <= lastIndex; i++) {
            let taxRate = $grid.dataView[i].tax_rate || 0;
            if (taxRate == $grid.$ms.constant.TaxRateInventory.NoSelected) {
              $grid.dataView[i].tax_amount = 0;
            } else {
              $grid.dataView[i].tax_amount = commonFn.roundDecimalDbOption(
                proxy.$ms.constant.DbOptionKey.CurrencyDecimalDigits,
                (taxRate * turnOver) / 100,
              );
            }
          }
          break;
        case 'amount':
        case 'amount_oc':
        case 'quantity':
          const metaDataTracking = {
            tracking: {
              newVal: objAssign[column.dataField],
            },
          };
          const direction = lastIndex > rowIndex ? -1 : 1;
          while (lastIndex != rowIndex + direction) {
            proxy.changeDataBusiness($grid, column, lastIndex, metaDataTracking, callbackUpdateRow);
            lastIndex += direction;
          }
          break;
        default:
          break;
      }
    }
    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.step-1',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        key: 1,
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.step-2',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.setting-small',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.ic-question',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },

      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Thêm nội dung chi tiền mặt`,
      },

      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Xóa nội dung chi tiền mặt`,
      },

      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Nhấn Cất để lưu thông tin`,
      },
      {
        target: '.step-5-pos',
        header: {
          title: 'Tiện ích',
        },
        state: ['posted', 'unposted'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ mới, Xem số dư tài khoản,...',
      },
      {
        target: '.step-6-pos',
        header: {
          title: 'Chức năng In',
        },
        state: ['posted', 'unposted'],
        content: `Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô`,
      },
      {
        target: '.step-7-posted',
        header: {
          title: 'Sửa nhanh',
        },
        state: ['posted'],
        content: `Thực hiện sửa một số thông tin chung trên chứng từ`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Bỏ ghi',
        },
        state: ['posted'],
        content: `Bỏ ghi sổ chứng từ để sửa hoặc xóa chứng từ`,
      },
      {
        target: '.step-7-unposted',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['unposted'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-8-unposted',
        header: {
          title: 'Sửa',
        },
        state: ['unposted'],
        content: `Sửa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Ghi sổ',
        },
        state: ['unposted'],
        content: `Ghi sổ chứng từ hiện thời`,
      },
    ]);

    /**
     * Event nút Sửa
     * vqphong - 13/12/2022
     */
    const onEditEvent = () => {
      // Check quyền Sửa (vqphong - 12/12/2022)
      proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
      proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
    };

    /**
     * Custom diễn giải theo đơn vị
     * pqkhanh 24.02.2023
     */
    const selectedAccountingObjectCAPayment = ({newData}, me) => {
      selectedAccountingObject({newData}, me);
      if (newData) {
        // nếu đơn vị có tên là misa
        if (
          (proxy.editMode === proxy.$ms.constant.FormState.Add ||
            proxy.editMode === proxy.$ms.constant.FormState.Edit) &&
          proxy.model.accounting_object_name.toLowerCase().includes('misa')
        ) {
          proxy.model.journal_memo = `Mã QHNS: ${proxy.dbOptions.CompanyCode}; Số HĐ: ...; Số điện thoại người thanh toán : ....; Thanh toán tiền mua phần mềm:...`;
        }
      }
    };

    /**
     * Xem số dư tạm ứng
     * NNLINH 10.05.2023
     */
    function getAdvanceBalance() {
      popupUtil.show('ViewAdvanceBalance', {
        postedDate: proxy.model.posted_date,
      });
    }

    /**
     * Có hiển thị chọn tham chiếu đến chứng từ hay không
     * @author NHCUONG 22.06.2023
     */
    const isShowVoucherReference = computed(() => {
      return refTypeAcceptVoucherReference.value.includes(refType.value);
    });

    /**
     * Hiển thị form tham chiếu Phiếu thu
     * @author NHCUONG 22.06.2023
     */
    function showFormVoucherReference() {
      if (!this.viewing)
        popupUtil.show('VoucherReference', {
          postedDate: proxy.model.posted_date,
          RefTypeView: getRefTypeView(),
          options: {
            submit: this.callbackChooseItem.bind(this),
          },
        });
    }

    /**
     * Lấy ref type tham chiếu
     * @author NHCUONG 22.06.2023
     */
    function getRefTypeView() {
      let refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
      switch (refType.value) {
        case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
          refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
          break;
        case proxy.$ms.constant.RefType.BAWithDraw:
        case proxy.$ms.constant.RefType.BAWithdrawPurchase:
        case proxy.$ms.constant.RefType.BAWithDrawFixedAsset:
        case proxy.$ms.constant.RefType.BAWithdrawVendor:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
        case proxy.$ms.constant.RefType.GLGeneralVoucher:
          refTypeView = proxy.$ms.constant.DefaultValue.All;
          break;
        case proxy.$ms.constant.RefType.BUTransferDeposit:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
      }
      return refTypeView;
    }

    /**
     * Sự kiện khi chọn chứng từ tham chiếu từ grid danh sách
     * @author NHCUONG 22.06.2023
     */
    function callbackChooseItem(items) {
      setVoucherReferenceInfo(items);
      let grid = getGridDetail();
      if (grid) {
        initNewData(grid);
      }
    }

    /**
     * Gán thông tin tham chiéu
     * @author NHCUONG 22.06.2023
     */
    function setVoucherReferenceInfo(data) {
      voucherReferenceItems.value = data;
    }

    /**
     * Lấy grid detail
     * @NHCUONG 22.06.2023
     */
    function getGridDetail() {
      let keys = Object.keys(proxy._gridDetails);
      if (keys && keys.length > 0) {
        let refName = proxy._gridDetails[keys[0]];
        let gridRef = proxy.$refs[refName];
        if (gridRef) {
          return gridRef;
        }
        return null;
      }
      return null;
    }

    /**
     * Gán tiền cho dòng đầu tiên
     * @author NHCUONG 22.06.2023
     */
    function initNewData(grid) {
      if (voucherReferenceItems.value.length === 0) return;
      voucherReferenceItems.value.forEach((item, index) => {
        let col = grid.getColumns()[0];
        if(index > grid.dataView.length - 1){
          grid.addRow(index, index, false, col);
        }
        let rowUpdate = grid.dataView[index];

        item.from_ref_detail_id = rowUpdate.ref_detail_id;
        
        grid.changeEditor(null, index, col).then(() => {
          if (rowUpdate.state === proxy.$ms.constant.ModelState.Empty) {
            rowUpdate.state = proxy.$ms.constant.ModelState.Insert;
          }
          rowUpdate.amount = item?.remaining_amount || 0;
          rowUpdate.amount_oc = item?.remaining_amount || 0;
          rowUpdate.inward_amount = item?.remaining_amount || 0;
          if ((rowUpdate?.quantity || 0) !== 0) {
            rowUpdate.unit_price = rowUpdate.amount / rowUpdate.quantity;
          }
          rowUpdate.description = item?.description;
          rowUpdate.budget_source_id = item?.budget_source_id;
          rowUpdate.budget_source_code = item?.budget_source_code;
          rowUpdate.budget_source_name = item?.budget_source_name;
          rowUpdate.budget_kind_item_code = item?.budget_kind_item_code;
          rowUpdate.budget_sub_kind_item_code = item?.budget_sub_kind_item_code;
          rowUpdate.budget_chapter_code = item?.budget_chapter_code;
          rowUpdate.budget_item_code = item?.budget_item_code;
          rowUpdate.budget_sub_item_code = item?.budget_sub_item_code;

          rowUpdate.task_code = item?.task_code;
          rowUpdate.task_id = item?.task_id;

          rowUpdate.statistic_code = item?.statistic_code;
          rowUpdate.statistic_id = item?.statistic_id;

          rowUpdate.project_code = item?.project_code;
          rowUpdate.project_id = item?.project_id;
        });
      });

      while(grid.dataView.length > voucherReferenceItems.value.length){
        proxy.model.Detail.pop();
      }
    }

    /**
     * Xóa chứng từ tham chiếu
     * @author NHCUONG 22.06.2023
     */
    function removeVoucherReference() {
      voucherReferenceItems.value = {};
    }

    /**
     * Custom hàm thông báo lỗi khi validate tham chiếu chứn từ
     * @author NHCUONG 22.06.2023
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        isAcceptValidateVoucherReference.value = false;
        let errorData = error.response.data;
        if (errorData.Error === proxy.$ms.constant.ErrorCodes.ValidateAmountVoucherReference) {
          let {Data} = errorData.Data;
          let message = `Số tiền trên chứng từ <span style="font-weight: bold;">${proxy.model.ref_no}</span> vượt quá số tiền rút dự toán trên chứng từ <span style="font-weight: bold;">${Data.ref_type_name} - ${Data.ref_no}</span>. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?`;
          let title = 'Quỹ tiền âm';
          showConfirm(message, title, 410).then(async answer => {
            if (answer) {
              proxy.super('commandClick', baseDetailVoucher, proxy.$ms.constant.Command.SaveView);
              isAcceptValidateVoucherReference.value = true;
            }
          });
        } else {
          proxy.super('saveError', baseDetail, error, param, action);
        }
      }
    }

    const meInvoiceConnectInfo = ref(null);
    /**
     * Hiển thị target link khi xem chứng từ
     * @author NHCUONG 26.06.2023
     */
    function showTargetLink(item) {
      if (proxy._formParam?.isCreateFromInbot || item.invoice_id) {
        if (!meInvoiceConnectInfo.value) {
          IntegrationInvoiceBotApi.checkConnect().then(res => {
            if (res) {
              meInvoiceConnectInfo.value = res.MeInvoiceConnectND51;
            }
          });
        }
        popupUtil.show('InvoiceBotDetail', {
          // mode: proxy.$ms.constant.FormState.View,
          id: item.invoice_id,
          meInvoiceConnectInfo: meInvoiceConnectInfo.value,
        });
      } else {
        proxy.super('showTargetLink', baseDetailVoucher, item);
      }
    }

    /**
     * Gán dữ liệu sinh từ InBot
     * Created by NNKiem 06/11/2023
     */
    async function bindDataFromInbot(data, dataInbot, dataInbotDetail, dataInbotTax) {
      Object.assign(data, dataInbot);
      data.Detail = [];
      dataInbotDetail.forEach(detail => {
        data.Detail.push(detail);
      });
      if (dataInbotTax?.length > 0) {
        data.CAPaymentDetailTax = dataInbotTax;
      }
      // chỉ tham chiếu đến thằng đầu tiên
      voucherReferenceItems.value = proxy._formParam.dataInvoiceBot;
      //Sinh hạch toán đồng thời
      await proxy.generateParallel(true, true);
    }

    /**
     *  Xử lý sau khi cất chứng từ
     *  Created by NNKiem 06/11/2023
     */
    function afterSubmitModeView(result, param) {
      if (
        proxy._formParam &&
        proxy._formParam.dataInbot &&
        proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0 &&
        isInvoiceInbotReference.value
      ) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: true,
          refNo: result.ref_no,
          // HMDUC2: Thêm biến phục vụ cập nhật refno_finance ngoài ds invoicebot_list
          isUpdatePosted: true,
          refNoBeforeUpdate: JSON.parse(proxy.refNoBeforeUpdate),
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
    }

    /**
     * Xử lý sau khi xóa chứng từ
     * Created by NNKiem 06/11/2023
     */
    function deleteSuccess(record, result) {
      if (proxy._formParam && proxy._formParam.dataInbot && proxy._formParam.dataInbot.ListInvoiceInbot?.length > 0) {
        //Update lại hạch toán màn hình danh sách
        let payload = {
          ids: proxy._formParam.dataInbot.ListInvoiceInbot,
          isPosted: false,
          refNo: null,
          refNoDelete: record?.ref_no, // HMDUC2 02/01/2023: Lưu lại ref_no ct xóa thành công phục vụ cập nhật lại chứng từ hoạch toán invoicebot_list
        };
        proxy.$store.dispatch('moduleInvoiceBot/updatedPosted', payload);
      }
      proxy.super('deleteSuccess', baseDetailVoucher, record, result);
    }

    /**
     * Override sự kiện khi đóng form
     * mở lại form hóa đơn khi sinh chứng từ
     * NHANH3 24.11.2022
     */
    function beforeClose(e) {
      if (proxy._formParam.options && typeof proxy._formParam.options.submitData === 'function') {
        proxy._formParam.options.submitData();
      } else {
        proxy.super('beforeClose', baseDetailVoucher, e);
      }
    }
    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_no, ref_type }) => ({ ref_id, ref_no, ref_type }))];
    }

    /**
     * @override lại Hàm custom sau khi ghi sổ thành công => xử lý show form hạch toán chi phí lương
     * DTQUOC 13.03.2024
     */ 
    async function customPostedSuccess(res, param) {
      const me = this;
      let details = {...proxy.model};
      details.IsGenerateData = true;
      proxy.setFormMode(proxy.$ms.constant.FormState.View);
      let dataTrans = await GLVoucherAPI.getDataByRelationRefId(details.ref_id);
      if(dataTrans) {
        let mes = proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncFundSalaryContent');
        showConfirm(
          mes.format('Phiếu chi', dataTrans.ref_no),
          proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherTitle'),
        ).then(answer => {
          switch (answer) {
            case true:
              // check quyền Sửa (vqphong - 12/12/2022)
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
              details.IsSyncData = true;
              popupUtil.show('GLGeneralVoucherDetail', {
                mode: proxy.$ms.constant.FormState.Edit,
                refType: proxy.model.ref_type,
                // id: proxy.model.ref_id,
                data: details,
                options: {
                  submit: data => {
                    proxy.view({
                      id: proxy.model.ref_id,
                      mode: proxy.$ms.constant.FormState.View,
                    });
                  },
                },
              });
              break;
            case false:
              break;
          }
        });
      }else {
        if(details.Detail) {
        let valueCheck = details.Detail.some((item) => {
          return item.debit_account.startsWith("334");
        });
        if(valueCheck) {
          showConfirm('Bạn có muốn sinh chứng từ Hạch toán chi phí lương không?', 'Sinh chứng từ').then(answer => {
            switch(answer) {
              case true:
              generateGLVoucher();
              break;
              case false:
              break;
            }
          })
        }
      }
      }
      //NNLINH 01.02.2023 custom cho phần view linkForm thuế
      if (me.options && typeof me.options.submitViewLinkFormTax === 'function') {
        me.options.submitViewLinkFormTax(res, param);
      }
    }
    
    /**
     * Lấy tên model lưu dữ liệu grid thuế
     */
    function getTaxKeyModel() {
      return "CAPaymentDetailTax"
    }

    return {
      titleCode,
      module, // module form cha
      //tên router form danh sách khi đóng sẽ quay lại
      backRouter: '/cash/capayment',
      bindDataFromInbot,

      toggleAbove, // Value đóng mở thu gọn
      toggleAboveHandler, // Action thu gọn form
      selectedTab, // Value hiển thị tab
      selectedTabHandler, // Xử lý active tab các grid chi tiết

      autoBusiness,
      buttonUtilities,
      buttonPrints,
      // Cấu hình Field trong grid
      columnParallel,
      propsData, // Chứa config các field trong grid

      currencyAPI,
      comboboxLoadData, //  Call API lấy dữ liệu combo
      submitQuickAdd,
      comboboxDataRemote, // Object chưa data của các combo

      // column combo
      projectColumns,
      bankColumns,
      accountColumns,
      currencyColumns,
      columnsDataParalell,

      clickItemHandle,
      changeDataBusiness,

      getSaveData, // override lấy tham số để save

      //xử lý sự kiện select trên combo
      selectedAccountingObject,
      assignValueCurrency,
      selectCurrency,
      onActionBlur,
      totalAmountComputed,
      onCurrencyComboboxLoadData,

      onAccountingObjectComboboxLoadData,
      customVoucherLoadData,

      layoutTagDetail,
      currentLayout,
      layoutTagDetailOther,
      customColumns,
      toggleAboveHandlerGrid,

      onBlurActionDatePicker,
      onClickCKC,

      refType,
      clickQuickAccounting,
      accountingActions,
      saveAsNewAutoBusiness,
      defaultData,
      getConfigLayout,
      bindData,
      alwayTakeColumns,
      quickAddMultiItems,
      customDefaultData,
      disabledDelete,
      getParallelModel,
      currencyCode,
      useTA,
      itemCLick,
      beforeBindData,
      getCustomReportParams,
      copyDownRow,
      copyDownRowExtend,
      copyActionClick,
      steps,
      onEditEvent,
      subSystemCode,
      quickSearchParam,
      bindDefaultData,
      showRefNoInvoice,
      isViewInvoce,
      selectedAccountingObjectCAPayment,
      onPosted,
      customUnPostedSuccess,

      isShowVoucherReference,
      voucherReferenceItems,
      showFormVoucherReference,
      getRefTypeView,
      callbackChooseItem,
      setVoucherReferenceInfo,
      getGridDetail,
      initNewData,
      removeVoucherReference,
      saveError,
      showTargetLink,

      configAccountingGrid,
      configTaxGrid,
      configParallelGrid,
      stepsDynamic,
      accountingObjectCombo,
      afterSubmitModeView,
      deleteSuccess,
      changeTriggers,
      changeTriggerTaxs,
      changeTriggerPallers,
      beforeClose,
      viewAccount,
      refNoBeforeUpdate,
      DBStartDateString: proxy.DBStartDateString,
      isShowRiskPopup,
      isShowQuestionIcon,
      riskWarningMessage,
      validateRiskCustomerVendor,
      getParamDeleteDetail,
      customPostedSuccess,
      getTaxKeyModel
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    accountingObjectCombo() {
      return this.accountingObjectCombo
        .sort(function (a, b) {
          return a.accounting_object_code - b.accounting_object_code;
        })
        .sort(function (a, b) {
          return a.is_employee - b.is_employee;
        });
    },
  },
};
</script>

<style lang="scss">
.capayment-detail {
  @import './CAPaymentDetail.scss';
  &.btn {
    .icon-button {
      background: none !important;
    }
  }
}
</style>
